import React, { useState, useEffect } from "react";
import "./Contact.css";
import { projectFirestore } from "../firebase/config";
import Navbar from "./Navbar";
import Footer from "./Footer";
import contact from "../assets/contact.png";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const [loader, setLoader] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);

    projectFirestore
      .collection("contacts")
      .add({
        name: name,
        email: email,
        message: message,
      })
      .then(() => {
        setLoader(false);
        alert("Your message has been submitted👍");
      })
      .catch((error) => {
        alert(error.message);
        setLoader(false);
      });

    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <div>
      <Navbar />
      <div className="contact">
        <div className="row1">
          <img src={contact} alt="..." />
        </div>
        <div className="row2">
          <form className="contact-form" onSubmit={handleSubmit}>
            <h1>Contact Us 🤳</h1>

            <label>Name</label>
            <input
              placeholder="Name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <label>Email</label>
            <input
              placeholder="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <label>Message</label>
            <textarea
              placeholder="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            ></textarea>

            <button
              type="submit"
              style={{ background: loader ? "#ccc" : "rgb(24, 80, 236)" }}
            >
              Submit
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
